const assetClasses = {
    item: 'i',
    controls: 'actrl',
    checkBtb: 'ac',
    settingBtn: 'as',
    name: 'n',
    legend: 'l',
    attributes: 'aa',
    animatedThumb: 'tha',
    thumbInactive: 'thia',
    thumbWrapper: 'tw',
    toggleFormat: 'toggle-format',
    sectionDivider: 'section-div',
    assetToolbar: 'asset-toolbar',
    assetsActions: 'asset-actions',
    tagList: 'asset-tag-list',
    collectionList: 'asset-collection-list',
    privacy: 'asset-privacy',
    fileIcon: 'asset-file-icon',
    scrollable: 'asset-scrollable',
    videoPlayer: 'asset-vp',
    videoPlayerActions: 'vp-actions',
    videoPlayerPlaying: 'asset-playing',
    audioPlayer: 'asset-vp',
    audioPlayerActions: 'vp-actions',
    audioPlayerPlaying: 'asset-playing',
    assetChip: 'asset-chip',
    storyThumb: 'story-tb',
    storyThumbsLoaded: 'story-tbl',
    storyShouldHide: 'story-sh',
    assetIcon: 'asset-icon',
    deleted: 'a-deleted',
};

export default assetClasses;
